(function () {
  'use strict';

  angular
    .module('app.core')
    .service('academicService', academicService);

  function academicService( $http) {
    /* jshint validthis: true */
    var vm = this;

    vm.get = get;
    
    function get(studentId){
    	return $http.get('/api/students/'+ studentId +'/academic').then(fetchData);
    	
    }
    
    function fetchData(response){
    	return response.data;
    	
    }

    
  }
})();